import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom';
import $ from 'jquery';
import {API_ROOT, IMAGE_ROOT} from "../api-config";
import axios from "axios";
import Swal from "sweetalert2";
import Modal from "react-responsive-modal";
import {withTranslation} from 'react-i18next';
import i18n from '../i18n';
class Forgot_Password extends Component {

    constructor(props) {
        super(props);

        this.state = {
            redirect: false,
            windowHeight: 0,
            swalButton: '',
            open: false,
        };
        this.updateState = this.updateState.bind(this);
    };


    onOpenModal = () => {
        this.setState({open: true});

    };
    onCloseModal = () => {
        this.setState({open: false});
    };

    updateState(e) {
        this.setState({});
    }

    componentWillMount() {
        var height = $(window).height();

        this.setState({windowHeight: height});
        this.setState({
            swalButton: Swal.mixin({
                customClass: {
                    confirmButton: 'link_button',
                    cancelButton: 'link_button'
                },
                buttonsStyling: false,
            })
        });
        if(!localStorage.getItem("store_language")){
            localStorage.setItem("store_language","en")
        }
        i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
        });
    }

    componentDidMount() {

        document.title = "Forgot Password - " + localStorage.getItem("store_name") + " - Order Anywhere";

        var primaryColor = localStorage.getItem("store_primary_color");

        if (primaryColor != null) {
            document.documentElement.style.setProperty('--primaryColor', primaryColor);
        }
        var secondaryColor = localStorage.getItem("store_secondary_color");


        if (secondaryColor != null) {
            document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
        }

        var lightColor = localStorage.getItem("store_light_color");

        if (lightColor != null) {
            document.documentElement.style.setProperty('--lightColor', lightColor);
        }
        var buttonColor = localStorage.getItem("store_button_color");

        if (buttonColor != null) {
            document.documentElement.style.setProperty('--buttonColor', buttonColor);
        }


        $('#home').css('background', 'none');

        $('#submitButton').click(e => {


            if (this.toVerify()) {
                this.onOpenModal();
                axios.post(API_ROOT + '/forgotpassword', {
                    customer_username: $('#customer_username').val(),
                    store_id: localStorage.getItem("store_id"),
                    merchant_id: localStorage.getItem("merchant_id"),
                })
                    .then((response) => {

                        this.onCloseModal();

                        if (response.data.status === 1) {

                            //  this.state.swalButton.fire(response.data.message);
                            this.setState({redirect: true});
                        } else {

                            this.state.swalButton.fire(response.data.message);

                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

            }

        });
    }

    toVerify() {

        var customerUsername = $('#customer_username').val();


        if (customerUsername == '' || customerUsername == null) {
            this.state.swalButton.fire(i18n.t('phone_email_validation'));
            return false;


        }

        return true;

    }


    render() {
        const {open} = this.state;
        const {t} = this.props;
        if (this.state.redirect) {
            return <Redirect to="/changepassword/confirm"/>;
        }
        return (
            <div className="mainContainer">
                <header className="fixedHeader">
                    <div className="col-md-12 col-sm-12 col-xs-12 previous-link">
                        <Link to={'/login'}></Link>
                        <h2 className="text-center"><strong>{t('forgot_password')}</strong></h2>
                    </div>
                </header>
                <div className="mt-white h-100 middleContent" style={{height:"100vh"}} >
                    <div className="simple-box m-b-0 p-b-35 bkg-white h-100" style={{height:"100%"}}>
                        <div className="form-box w-75 div-center">
                            <div className="header-title">
                                <h2 className="text-center font-size-20 m-0">{t('forgot_your_password')}</h2>

                                <h5 className="subHeader">{t('forgot_disclaimer')}</h5>
                                <div className="border-bottom"></div>
                            </div>

                            <div className="form-group">
                                <label>{t('mobile_or_email')}*</label>
                                <input type="text"   id="customer_username" className="form-control"/>
                            </div>

                            <div className="form-group m-t-30 btn-red m-b-30">
                                <input type="submit"  name="submitButton" id="submitButton"  value={t('reset_password')}/>
                            </div>
                        </div>


                    </div>
                </div>

                <Modal closeOnEsc={false} closeOnOverlayClick={false} showCloseIcon={false} open={open}
                       onClose={this.onCloseModal} center>
                    <h2>&nbsp;&nbsp;&nbsp;&nbsp;{t('processing')}...&nbsp;&nbsp;&nbsp;&nbsp;</h2>

                    <p style={{textAlign: 'center'}}>
                        <img width={'40'} height={'40'} src={'/img/loader.gif'}/>
                    </p>
                </Modal>
                <div className="clearfix"></div>
            </div>
    );
    }
    }

export default withRouter(withTranslation()(Forgot_Password));



// WEBPACK FOOTER //
// ./src/view_components/forgot_password.js